import { required, maxLength } from 'vuelidate/lib/validators';

export default {
    required,
    maxLength: maxLength( 191 )
};